import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import './Schedule.css';

export const Schedule = () => {
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <section className="snn-page-section">
          <h2 className="snn-title">Programa</h2>
          {/*<div className="schedule-links-wrapper">*/}
          {/*  <p>*/}
          {/*    <a*/}
          {/*      className="email-link"*/}
          {/*      href="https://nnsymposium.s3.us-west-1.amazonaws.com/schedule/O4F_SNN-2024-Program.pdf"*/}
          {/*    >*/}
          {/*      <span className="material-symbols-outlined">download</span> Download program*/}
          {/*    </a>*/}
          {/*  </p>*/}
          {/*  <p>*/}
          {/*    <a*/}
          {/*      className="email-link"*/}
          {/*      href="https://nnsymposium.s3.us-west-1.amazonaws.com/schedule/SNN+2024_POSTER+SESSION_1_EVEN.pdf"*/}
          {/*    >*/}
          {/*      <span className="material-symbols-outlined">download</span> Download program -*/}
          {/*      Session poster 1*/}
          {/*    </a>*/}
          {/*  </p>*/}
          {/*  <p>*/}
          {/*    <a*/}
          {/*      className="email-link"*/}
          {/*      href="https://nnsymposium.s3.us-west-1.amazonaws.com/schedule/SNN2024_POSTER+SESSION_2_ODD.pdf"*/}
          {/*    >*/}
          {/*      <span className="material-symbols-outlined">download</span> Download program -*/}
          {/*      Session poster 2*/}
          {/*    </a>*/}
          {/*  </p>*/}
          {/*</div>*/}
          <div className="schedule-grid">
            <div className="schedule-grid-day">
              <h3 className="schedule-grid-day-title">Día 1</h3>
              <h2 className="schedule-grid-day-date">Jueves, 11 de septiembre</h2>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">8:00 AM - 8:30 AM</p>
                <p>
                  Registro <br/>
                  <small className="schedule-grid-event-location">Auditorio CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">8:30 AM - 9:00 AM</p>
                <p>
                  Inauguración <br/>
                  <small className="schedule-grid-event-location">Auditorio CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">9:00 AM - 10:00 AM</p>
                <p>
                  <small className="schedule-grid-event-location">Plenaria 1 ✨</small>
                  <br/>
                  Termodinámica Molecular Cuántica
                  <br />
                  Dr. Alejandro Gil Villegas Montiel <br/>
                  <small className="schedule-grid-event-location">Auditorio CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">10:00 AM - 10:30 AM</p>
                <p>
                  <small className="schedule-grid-event-location">Charla invitada 1</small>
                  <br/>
                  Cuantificadores de la no clasicidad en el procesamiento de información
                  cuántica en el régimen de respuesta lineal.
                  <br/>
                  M.Cs. Abril Andrea Jiménez Romero <br/>
                  <small className="schedule-grid-event-location">Auditorio CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">10:30 AM - 11:00 AM</p>
                <p>
                  Pausa para café ☕️
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">11:00 AM - 12:00 AM</p>
                <p>
                  <small className="schedule-grid-event-location">Plenaria 2 ✨</small>
                  <br/>
                  Intenso pero cuántico: hacia luz cuántica intensa y no gaussiana
                  <br />
                  Dra. Carla Hermann Avigliano
                  <br/>
                  <small className="schedule-grid-event-location">Auditorio CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">12:00 PM - 12:30 PM</p>
                <p>
                  <small className="schedule-grid-event-location">Charla invitada 2</small>
                  <br/>
                  Efectos de ordenamiento temporal en procesos no lineales de tercer orden implementados en guías de ondas integradas
                  <br />
                  M.Cs. Ferney Castro Simanca <br/>
                  <small className="schedule-grid-event-location">Auditorio CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">12:30 PM - 1:00 PM</p>
                <p>
                  <small className="schedule-grid-event-location">Charla invitada 3</small>
                  <br/>
                  Revolucionando el Diagnóstico Médico con Cómputo Cuántico: Clasificación Inteligente de Fracturas Vertebrales
                  <br />
                  Dr. Oscar H. Montiel Ross <br/>
                  <small className="schedule-grid-event-location">Auditorio CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">1:00 AM - 2:00 PM</p>
                <p>
                  <small className="schedule-grid-event-location">Plenaria 3 ✨</small>
                  <br/>
                  Sensores inerciales
                  <br />
                  Dr. Eduardo Gómez García <br/>
                  <small className="schedule-grid-event-location">Auditorio CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">2:00 PM - 4:00 PM</p>
                <p>
                  Pausa para comer
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">4:00 PM - 5:00 PM</p>
                <p>
                  <small className="schedule-grid-event-location">Plenaria 4 ✨</small>
                  <br/>
                  Destilación de estados mágicos lógicos con átomos neutros
                  <br />
                  Dr.  Sergio Cantú <br/>
                  <small className="schedule-grid-event-location">Auditorio CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">5:00 PM - 7:00 PM</p>
                <p>
                  Sesión de pósters <br/>
                  <small className="schedule-grid-event-location">Sala de usos múltiples</small>
                </p>
              </div>
            </div>
            <div className="schedule-grid-day">
              <h3 className="schedule-grid-day-title">Día 2</h3>
              <h2 className="schedule-grid-day-date">Viernes, 12 de septiembre</h2>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">9:00 AM - 11:00 AM</p>
                <p>
                  Visita a laboratorios <br/>
                  <small className="schedule-grid-event-location">Depto. de Óptica del CICESE</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">11:00 AM - 1:00 AM</p>
                <p>
                  Panel de expertos <br/>
                  <small className="schedule-grid-event-location">Aula 2 de Electrónica y Telecomunicaciones</small>
                </p>
              </div>
              <div className="schedule-grid-event">
                <hr/>
                <p className="schedule-grid-event-hour">1:00 AM - 2:00 PM</p>
                <p>
                  <small className="schedule-grid-event-location">Plenaria 5 y Clausuara del simposio ✨</small>
                  <br/>
                  Caos y termalización en sistemas cuánticos
                  <br />
                  Dr. Jorge G. Hirsch <br/>
                  <small className="schedule-grid-event-location">Aula 2 de Electrónica y Telecomunicaciones</small>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer/>
    </>
  );
};
